<template>
  <component :is="tag" class="configurator-product-item shadowed-cup__hover">
    <input
      v-model.number="computedValue"
      class="configurator-product-item__input"
      type="radio"
      :value="value"
      v-bind="{ name, id }"
    />

    <label :for="id" class="configurator-product-item__label" :title="label">
      <span class="configurator-product-item__thumbnail-wrapper">
        <ConfiguratorCup
          :src="imgUrl"
          type-id="1"
          :size-id="sizeId"
          :alt="label"
          class="configurator-product-item__thumbnail"
        />
        <span v-if="printType" class="configurator-product-item__print-type">
          <span class="configurator-product-item__print-type-label">
            <!-- TODO Do stuff here -->
          </span>
        </span>
      </span>
    </label>
  </component>
</template>

<script>
import { randomStr } from '../../utils/String';
import ConfiguratorCup from './ConfiguratorCup';

export default {
  name: 'ConfiguratorProductItem',
  components: { ConfiguratorCup },
  model: {
    prop: 'activeValue',
    event: 'change',
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      default: undefined,
    },
    id: {
      type: String,
      default: () => randomStr(),
    },
    label: {
      type: String,
      default: undefined,
    },
    printType: {
      type: String,
      default: undefined,
    },
    imgUrl: {
      type: String,
      default: undefined,
    },
    activeValue: {
      type: Number,
      default: undefined,
    },
    sizeId: {
      type: Number,
      default: undefined,
    },
    tag: {
      type: String,
      default: 'div',
    },
  },
  data() {
    return {
      localValue: null,
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.localValue;
      },
      set(v) {
        this.localValue = v;

        this.$emit('change', v);
      },
    },
  },
  watch: {
    activeValue: {
      handler(v) {
        this.localValue = v;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-product-item {
  $block-selector: &;
  display: flex;
  flex: 1;
  min-width: 0;
  position: relative;

  &__input {
    @include sr-only();
  }

  &__label {
    display: flex;
    border: solid 1px $color-gray-gallery;
    border-radius: 0.75rem;
    flex-direction: column;
    padding: 0.5em;
    flex: 1;
    min-width: 0;
    cursor: pointer;
    transition: background-color $default-transition-duration;
    background-color: transparent;

    &:hover {
      background-color: color.adjust($color-red-amaranth, $lightness: 90%);
    }

    #{$block-selector}__input:checked + & {
      border: solid 2px $color-red-amaranth;
      padding: 0.4375rem;
      background-color: $color-gray-wild-sand;
    }
  }

  &__thumbnail-wrapper {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    margin-bottom: 0.5em;
  }

  &__thumbnail {
    height: 100%;
  }

  ::v-deep .configurator-cup {
    height: 100%;
  }
}
</style>
